import React from 'react';
import './styles.scss';

const CheckboxGroup = ({ label, children }): JSX.Element => (
  <fieldset
    className="MuiFormControl-root teams-checkbox-group"
    data-testid="checkbox-group-state"
  >
    <legend className="MuiFormLabel-root">{label}</legend>
    <div
      className="MuiFormGroup-root teams-checkbox-group--children-wrapper"
      data-testid="checkbox-group-state"
    >
      {children}
    </div>
  </fieldset>
);

export default CheckboxGroup;
